import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { HelpCircleIcon, XIcon } from 'lucide-react';
import { BUILDER_ID } from '../data/builder';
import { useElementInView } from '../hooks/useElementInView';
interface ObjectionTeaserProps {
  visible: boolean;
  onExpand: () => void;
  onDismiss: () => void;
}

/**
 * Small corner button that offers help without taking over the screen. Sits
 * above the mobile sticky bar and hides whenever the builder is on screen.
 */
export function ObjectionTeaser({
  visible,
  onExpand,
  onDismiss
}: ObjectionTeaserProps) {
  const builderInView = useElementInView(BUILDER_ID);
  const show = visible && !builderInView;
  return <AnimatePresence data-id="element-911" data-mp="3lpp43qdgkvg0">
      {show && <motion.div initial={{
      opacity: 0,
      y: 8,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 8,
      scale: 0.96
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-[5.5rem] left-3 z-30 flex items-stretch border border-grit-500/60 bg-ink-950 shadow-lg lg:bottom-6 lg:left-6" data-id="element-912" data-mp="3lonr3gcvtyvn">
          <button type="button" onClick={onExpand} className="flex items-center gap-2 px-3 py-2 text-[11px] font-extrabold uppercase tracking-[0.14em] text-offwhite transition-colors duration-150 ease-grit hover:text-grit-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-grit-500" data-id="element-913" data-mp="1e0hoyfqjl31t">
            <HelpCircleIcon className="h-4 w-4 text-grit-500" aria-hidden="true" data-id="element-914" data-mp="21v28l1kphhy8" />
            Still deciding?
          </button>
          <button type="button" onClick={onDismiss} aria-label="Dismiss" className="flex items-center border-l border-white/10 px-2 text-steel-400 transition-colors duration-150 ease-grit hover:text-offwhite focus:outline-none focus-visible:ring-2 focus-visible:ring-grit-500" data-id="element-915" data-mp="2bnq5rxfllnxh">
            <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-916" data-mp="2fqefs8g1t0w1" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}